import {InjectionToken} from '@angular/core';

export const TISA_CLOUDFRONT_ID = new InjectionToken<string>('Provides CloudFront id.');
